<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <service-category-editor
        v-model="form"
        :icon-url="iconUrl"
      ></service-category-editor>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { backendAdminClient } from "@/dependencies"
import { uploadPublicImage } from "@/god"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import ServiceCategoryEditor from "../components/ServiceCategoryEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceCategoryEditor,
  },
  data() {
    const title = "เพิ่มหมวดหมู่"
    const form = {
      name: "",
      services: [],
      iconFile: null,
    }

    const iconUrl = null

    return {
      title,
      form,
      iconUrl,
    }
  },
  watch: {
    form(form, oldForm) {
      if (this.form.iconFile === oldForm.iconFile) {
        return
      }

      this.iconUrl = URL.createObjectURL(this.form.iconFile)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {},
    async handleClickSave() {
      try {
        await this.create()
        this.$router.push({ name: "ServiceCategoryListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async create() {
      const { name, iconFile, services } = this.form
      const icon = await uploadPublicImage(iconFile, name, "article")

      const params = {
        name,
        icon,
        serviceIds: services.map(({ id }) => id),
      }

      const response =
        await backendAdminClient.serviceCategory.createServiceCategory(params)

      return response.data.result
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
